import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { IStopSaleListState } from '../../../../types/stopSale/stopSalesTypes';
import { useSearchParams } from '../../../../customHooks/useSearchParams';
import DotIcon from '../../../components/DotIcon';
import Tooltip from '../../../../muiComponents/Tooltip';
import routes from '../../../../utils/commonVariables/routes';
import { categorizePeriod, formatDate } from '../../../../utils/formatDates';
import Tag from '../../../../muiComponents/Tag';
import { STOP_SALES_DATE_TAG_COLOR } from '../../../../utils/stopSales/stopSalesUtils';

interface StopSalesRowProps {
    stopSale: IStopSaleListState;
}

const StopSalesRow = (props: StopSalesRowProps) => {
    const { stopSale } = props;

    const { setSearchParam } = useSearchParams({ base64: true });
    const handleRowClick = (idTax: string) => {
        setSearchParam('id', idTax);
    };

    const linkToHotel = routes.propertyDetail(stopSale.IdSupplierHotel);
    const tagText = categorizePeriod(stopSale.FromDate, stopSale.ToDate);

    return (
        <TableRow
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => handleRowClick(stopSale.Id)}
        >
            <TableCell>
                <div className='flex-center'>
                    <DotIcon truthy={stopSale.Enabled} />
                </div>
            </TableCell>
            <TableCell>
                <Tooltip titleText='navigate_to_hotel_detail'>
                    <h6
                        className='tax__title link-onhover'
                        onClick={e => {
                            e.stopPropagation();
                            window.open(linkToHotel, linkToHotel);
                        }}
                    >
                        {stopSale.SupplierHotel}
                    </h6>
                </Tooltip>
            </TableCell>
            <TableCell>{stopSale.SupplierHotelRoomType}</TableCell>{' '}
            <TableCell>{stopSale.SupplierHotelRatePlan}</TableCell>
            <TableCell>{stopSale.SupplierHotelMealPlan}</TableCell>
            <TableCell style={{ maxWidth: '130px' }}>
                <div className='flex-column flex-align-end gap-10 height100perc flex-between'>
                    {formatDate(stopSale.FromDate)} -{' '}
                    {formatDate(stopSale.ToDate)}
                    <Tag
                        text={tagText}
                        color={STOP_SALES_DATE_TAG_COLOR[tagText]}
                    />
                </div>
            </TableCell>
        </TableRow>
    );
};

export default StopSalesRow;
